export const calculateIQScore = (
  correctAnswers: number,
  totalQuestions: number,
  level: string
): number => {
  const baseScore = (correctAnswers / totalQuestions) * 100;
  
  let multiplier = 1;
  if (level === 'intermediate') multiplier = 1.1;
  if (level === 'advanced') multiplier = 1.2;
  
  // IQ scoring: Average is 100, Standard deviation is 15
  // Perfect score maps to 145, zero score maps to 70
  const iqScore = 70 + (baseScore * multiplier * 0.75);
  
  return Math.round(Math.min(160, Math.max(70, iqScore)));
};

export const getPercentile = (iqScore: number): number => {
  // Approximation based on normal distribution
  // IQ of 100 is 50th percentile, 115 is ~84th, 130 is ~98th
  if (iqScore >= 145) return 99.9;
  if (iqScore >= 130) return 98;
  if (iqScore >= 120) return 91;
  if (iqScore >= 115) return 84;
  if (iqScore >= 110) return 75;
  if (iqScore >= 100) return 50;
  if (iqScore >= 90) return 25;
  if (iqScore >= 85) return 16;
  if (iqScore >= 80) return 9;
  return 5;
};

export interface IQCategory {
  label: string;
  description: string;
  color: string;
}

export const getIQCategory = (iqScore: number): IQCategory => {
  if (iqScore >= 140) {
    return {
      label: 'Genius',
      description: 'Exceptional intellectual ability',
      color: 'purple',
    };
  }
  if (iqScore >= 130) {
    return {
      label: 'Very Superior',
      description: 'Highly gifted intelligence',
      color: 'blue',
    };
  }
  if (iqScore >= 120) {
    return {
      label: 'Superior',
      description: 'Above average intelligence',
      color: 'teal',
    };
  }
  if (iqScore >= 110) {
    return {
      label: 'High Average',
      description: 'Above average cognitive ability',
      color: 'green',
    };
  }
  if (iqScore >= 90) {
    return {
      label: 'Average',
      description: 'Normal intelligence range',
      color: 'yellow',
    };
  }
  if (iqScore >= 80) {
    return {
      label: 'Low Average',
      description: 'Below average range',
      color: 'orange',
    };
  }
  return {
    label: 'Below Average',
    description: 'Lower cognitive range',
    color: 'red',
  };
};
